// src/layout/Navbar.js

import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import "./Navbar.css"

function Navbar() {
  const { isAuthenticated, email, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate("/")
  }

  return (
    <nav className="mynavbar">
      <div className="nav-left">
        <Link className="nav-logo" to="/">iFelt</Link>
        <Link className="nav-link" to="/">Emotion Wheel</Link>
        <Link className="nav-link" to="/search">Search for a movie</Link>
      </div>
      <div className="nav-right">
        {isAuthenticated ? (
          <>
            <span className="nav-user">{email}</span>
            <button className="nav-link nav-link--button" onClick={handleLogout}>Logout</button>
          </>
        ) : (
          <>
            <Link className="nav-link" to="/login">Login</Link>
            <Link className="nav-link" to="/register">Register</Link>
          </>
        )}
      </div>
    </nav>
  )
}

export default Navbar
